import React, { useMemo } from "react";
import { CodeWithChrome } from "~/components/Code/CodeWithChrome";
import type { ConfiguredSources } from "../ConfiguredSource";
import { createAnnotation } from "../createAnnotation";
import { sharedStyles } from "../sharedStyles";
type AnnotationsViewProps = {
    index: number;
    configuredSources: ConfiguredSources;
    isMultiSourceApplication: boolean;
};
export const AnnotationsView = (props: AnnotationsViewProps) => {
    const { index, configuredSources, isMultiSourceApplication } = props;
    const annotation = useMemo(() => createAnnotation(configuredSources, isMultiSourceApplication), [configuredSources, isMultiSourceApplication]);
    return (<div>
            <h2 className={sharedStyles.header}>{index}. Copy annotations</h2>
            <p>Add the annotations below to your Argo CD application manifest</p>
            <CodeWithChrome canCopy={true} canShowFullScreen={false} value={annotation} language={"YAML"}/>
        </div>);
};
